import React from 'react';
import { graphql } from 'gatsby';
import Layout from '../components/Layout';
import SEO from '../components/SEO';

const Basic = ({ data }) => {
  const { title } = data.markdownRemark.frontmatter;
  const { html } = data.markdownRemark;
  const { slug } = data.markdownRemark.fields;
  const excerpt = data.markdownRemark.excerpt || '魔鬼鱼订货平台';

  const breadcrumbSchema = {
    '@context': 'http://schema.org',
    '@type': 'BreadcrumbList',
    itemListElement: [
      {
        '@type': 'ListItem',
        position: 1,
        name: '首页',
        item: 'https://www.mantas.cn/'
      },
      {
        '@type': 'ListItem',
        position: 2,
        name: title,
        item: `https://www.mantas.cn${slug}`
      }
    ]
  };

  return (
    <Layout bodyClass="page-default-single">
      <SEO title={`${title} - 魔鬼鱼订货平台`} description={excerpt} path={slug} />
      <article className="container pb-6 pt-6 pt-md-10 pb-md-10">
        <div className="row justify-content-start">
          <div className="col-12 col-md-8">
            <h1 className="title">{title}</h1>
            <div className="content" dangerouslySetInnerHTML={{ __html: html }} />
          </div>
        </div>
      </article>
      <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(breadcrumbSchema) }} />
    </Layout>
  );
};

export const query = graphql`
  query($id: String!) {
    markdownRemark(id: { eq: $id }) {
      frontmatter {
        title
        path
      }
      fields {
        slug
      }
      excerpt(pruneLength: 160)
      html
    }
  }
`;

export default Basic;
